module.exports = __webpack_public_path__ + "img/ic_price_v2.552b8ed.svg";